import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Spinner, Col, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import { useProvider, Toast, isNative } from '../context/MenuProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import AOS from "aos";
import 'aos/dist/aos.css';

import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");


const Sync = () => {
  const [logs, setLogs] = useState([]);
  const [lista, setLista] = useState([]);
  const { 
    setLinks, 
    setBtns,
    excluirDadosPorId,
    buscarDados,
    hasPerms,
  } = useProvider();
  const tipo = {
    POST:"Enviar cadastro",
    PUT:"Enviar alteração",
    PATCH:"Enviar parte de alteração",
    DELETE:"Excluir item",
    GET:"Buscar item",
  }
  
  
  useEffect(() => {
      setLinks([
       // { name: 'Configurar estoque (Casal)', to: '/estoque/sincronizar' },
       // { name: 'Sincronizar produtos', to: '/estoque/sincronizar' },
      ]);
      
      setBtns([
        //{icon:'bi-funnel', onClick:() => {alert("ok");}},
      ]);
      return () => {setLinks([]); setBtns([]);}
    }, [setLinks, setBtns, lista]);
    

  useEffect(() => {
    const buscarSync = async () => {
      try {
        const response = await buscarDados(
          'db_sync',
          (item) => {
              return !(!!item?.is_sincronizado);
          }, 
          50,
          "data",
          'asc'
        );
        setLista(response || []);
      } catch (err) {
        console.error("Erro ao carregar dados:", err);
      }finally{
        buscarLogSync();
      }
    };
    const buscarLogSync = async () => {
      try {
        const response = await buscarDados(
          'db_logs',
          (item) => {
              return true;
          }, 
          50,
          'data',
          'desc',
        );
        //alert(JSON.stringify(response))
        setLogs(response || []);
      } catch (err) {
        console.error("Erro ao carregar logs:", err);
      }
    };
  
    // Executa imediatamente
    buscarSync();
  
    const interval = setInterval(buscarSync, 2000); // a cada 2 segundos
  
    return () => clearInterval(interval); // limpa ao sair da tela
  }, []);
  
  const removerSync = async (item) => {
    Swal.fire({
      title: `Exluir ${item?.titulo||"item"} da fila?`,
      text: "Ao remover da fila, não será sincronizado com o servidor em nuvem.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim, excluir!"
    }).then(async(result) => {
      if (result.isConfirmed) {
        try{
          await excluirDadosPorId("db_sync", item.id);
          setLista(listaAtual => listaAtual.filter(i => i.id !== item.id));
          Toast.fire({
              icon: "success",
              title: `${item?.titulo||"Item"} excluído com sucesso`
          });
        }catch(err){
          Swal.fire({
            title: `Erro ${err.status}`,
            text: `${item?.titulo||"Item"} não pode ser excluído`,
            icon: "error"
          });
        }finally{
          
        }
      }
    });
  };
  
  const iniciarSync = async () => {
    if(isNative) window.dispatchNativeMessage('iniciar-sync');
    if(!isNative) navigator.serviceWorker.controller.postMessage('iniciar-sync');
  };
  const iniciarSyncGeral = async () => {
    if(isNative) window.dispatchNativeMessage('iniciar-sync-geral');
    if(!isNative) navigator.serviceWorker.controller.postMessage('iniciar-sync-geral');
  };
  
  return (
    <>
      <div className="mb-5">
        <div className="small text-muted">
          Aqui será exibida a lista de todos os itens que estão na fila de espera de conexão, aguardando para serem sincronizados com o servidor.
          <br />
          Esses itens serão sincronizados automaticamente assim que houver conexão disponível.
        </div>
        <Row>
          <Col className="text-center mt-2">
            <Button onClick={iniciarSync} variant="outline-success" className="px-5 my-1 mx-auto"><i className="bx bx-sync"></i>Sincronizar pendências</Button>
            <Button onClick={iniciarSyncGeral} variant="outline-success" className="px-5 my-1 mx-auto"><i className="bx bx-sync"></i>Sincronizar Tudo</Button>
            {lista?.length === 0 && (<>
              <div className="py-5 text-center text-muted">
                Fila de pendências vazia...
              </div>
            </>)}
          </Col>
        </Row>
        
        <div className="list-group mt-2">
          {lista?.length > 0 && (<>
              {lista.map((x) => (
                  <div>
                    <RenderizarProduto
                      key={x.id}
                      lm='my-1'
                      col='d-none'
                      text1={tipo[x.method]}
                      titulo={(
                        <>
                          {x.titulo}
                        </>
                      )}
                      bcolor={x.erro?'red':'inherit'}
                      extra={(<>
                        <code>
                          {x.erro && (<>
                            Tentativas:{x.tentativas} 
                            {` `}
                            Detalhes:{x.detail}
                          </>)}
                        </code>
                        {x.descricao && (
                          <div dangerouslySetInnerHTML={{ __html: x.descricao }} />
                        )}
                        {(x.dados && hasPerms(["loja.view_customsite"])) && (<>
                          <div className="d-flex flex-nowrap overflow-auto">
                            <code>{JSON.stringify(x.dados)}</code>
                          </div>
                        </>)}
                        
                        <div className="pt-2 mt-2 border-top">
                          <Row>
                            <Col>
                              {x.data && (
                                <div className="text-muted">
                                  {dayjs(x.data).format("DD/MMM [às] HH:mm")}
                                </div>
                              )}
                            </Col>
                            <Col xs="auto">
                              <Button onClick={()=>removerSync(x)} variant="outline-danger" className="btn-sm ms-1"><i className="bx bx-x"></i>Remover</Button>
                            </Col>
                          </Row>
                        </div>
                      </>)}
                    />
                  </div>  
                ))}
          </>)}
        </div>
        <div className="list-group mt-2 small">
          {logs?.length > 0 && (<>
              <div className="fs-5 text-muted small">Logs...</div>
              {logs.map((x) => (
                  <div>
                    <RenderizarProduto
                      key={`log_${x.id}`}        
                      lm='my-1'
                      col='d-none'
                      text1={x.info}
                      extra={(<>
                        <div className="border-top">
                          <Row>
                            <Col>
                              {x.data && (
                                <div className="text-muted">
                                  {dayjs(x.data).format("DD/MMM [às] HH:mm")}
                                </div>
                              )}
                            </Col>
                          </Row>
                        </div>
                      </>)}
                    />
                  </div>  
                ))}
          </>)}
        </div>
      </div>
    </>
  );
};

export default Sync;